import { useEffect, useState } from 'react'
import { getInstructorById } from '@/services/instructorService'

// ผู้สอนของหนังสือ — ดึงจาก API ผู้สอนจริง (ใช้ instructor_id ที่ผูกไว้ในข้อมูลหนังสือ) จำผลไว้กันยิงซ้ำเมื่อการ์ดหลายใบใช้คนเดียวกัน
// ไม่มี instructor_id หรือโหลดไม่ได้ = null (หน้าที่เรียกใช้ซ่อนแถวผู้สอนเอง ไม่ error)
export interface BookInstructor {
  instructor_id: number
  name: string
  avatar_url: string
  bio: string | null
}

const cache = new Map<number, Promise<BookInstructor | null>>()

function load(id: number): Promise<BookInstructor | null> {
  let p = cache.get(id)
  if (!p) {
    p = getInstructorById(id)
      .then((i) => {
        const name = `${i.first_name} ${i.last_name}`.trim()
        return {
          instructor_id: i.instructor_id,
          name,
          avatar_url: i.avatar_url || `https://api.dicebear.com/9.x/notionists/svg?seed=${encodeURIComponent(name)}`,
          bio: i.bio ?? null,
        }
      })
      .catch(() => {
        cache.delete(id) // ล้มเหลวแล้วอย่าจำ — ให้ลองใหม่ได้
        return null
      })
    cache.set(id, p)
  }
  return p
}

export function useBookInstructor(instructorId: number | null | undefined): BookInstructor | null {
  const [state, setState] = useState<{ id: number | null; data: BookInstructor | null }>({ id: null, data: null })

  useEffect(() => {
    if (!instructorId) return
    let cancelled = false
    load(instructorId).then((data) => { if (!cancelled) setState({ id: instructorId, data }) })
    return () => { cancelled = true }
  }, [instructorId])

  return instructorId && state.id === instructorId ? state.data : null
}
